import * as v from 'valibot';

export const reactionsItem = v.object({
  post_id: v.number(),
  post_slug: v.string(),
  post_type: v.optional(v.string()),
  user_state: v.nullish(v.string()),
  updated_at: v.string(),
  created_at: v.string(),
  post_date: v.nullish(v.string()),

  thumbs_up_count: v.optional(v.number()),
  thumbs_up: v.optional(v.array(v.number())),
  thumbs_down_count: v.optional(v.number()),
  thumbs_down: v.optional(v.array(v.number())),
  on_fire_count: v.optional(v.number()),
  on_fire: v.optional(v.array(v.number())),
  angry_count: v.optional(v.number()),
  angry: v.optional(v.array(v.number())),
  heart_count: v.optional(v.number()),
  heart: v.optional(v.array(v.number())),
});

export const fetchReactionSchema = v.object({
  data: reactionsItem,
  meta: v.object({
    last_modified: v.number(),
  }),
  msg: v.string(),
  success: v.optional(v.boolean()),
});
